import OnvoBase from "../base.js";
import { AutomationRun } from "../types/automations.js";

export class OnvoAutomation extends OnvoBase {
  #id: string;

  constructor(id: string, apiKey: string, options?: { endpoint: string }) {
    super(apiKey, options);
    this.#id = id;
  }
  /**
   * Fetches all the runs of the automation
   * @returns {Promise<AutomationRun[]>} A promise that resolves to an array of AutomationRun objects
   */
  getRuns(): Promise<AutomationRun[]> {
    return this.fetchBase("/api/automations/" + this.#id + "/runs") as Promise<
      AutomationRun[]
    >;
  }

  /**
   * Tests the automation to see if it runs successfully
   * @returns {Promise<{success: boolean}>} A promise that resolves to a status of successful or not
   */
  test(): Promise<{ success: boolean }> {
    return this.fetchBase("/api/automations/" + this.#id + "/test") as Promise<{ success: boolean }>;
  }
}
